<template>
    <Layout navActive='home'>
        <div slot="main">
            <div class="banner">
                <swiper :options="swiperOption" v-if="bannerList.length > 1" class="swiper-no-swiping">
                    <swiper-slide v-for="(item,index) in bannerList" :key="index">
                        <a @click="bannerTo(item)"><img :src="item.bannerWebImg"/></a>
                    </swiper-slide>
                </swiper>
                <div v-if="bannerList.length === 1"><a @click="bannerTo(bannerList[0])"><img :src="bannerList[0].bannerWebImg"/></a></div>
            </div>
            <div v-for="(homeItem, index) in homeList" :key="index">
                <div class="group_introduction" v-if="homeItem.type === 'groupIntroduce'">
                    <div class="group_introduction_content">
                        <div class="title">
                            <p class="cn">{{groupIntroduce.titleCn}}</p>
                            <p class="en">{{groupIntroduce.titleEn}}</p>
                        </div>
                        <div class="content" :style="{flexDirection: groupIntroduce.isImageLeft?'row-reverse':'row'}">
                            <div class="editor-gen" v-html="isCn ? groupIntroduce.contentCn:groupIntroduce.contentEn"></div>
                            <div class="introduction_img">
                                <div><img :src="groupIntroduceList[0]"/></div>
                            </div>
                        </div>
                        <div class="get_more">
                            <span @click="goAboutIntro" class="btn-more">MORE<q-icon name="add"></q-icon></span>
                        </div>
                    </div>
                </div>
                <News class="news_block"  v-if="homeItem.type === 'safeService'" :newsTitle="news"></News>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/views/Layout.vue';
import News from '@/views/index/News.vue';
import ajax from '@/utils/ajax';

export default {
    name: 'home',
    components: {
        Layout,
        News,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            homeList: [],
            bannerList: [],
            groupIntroduce: {},
            groupIntroduceList: [],
            news: {},
            swiperOption: {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true,
            },
        };
    },
    created() {
        ajax.get('/web/homepage/homepage_list.json', { }).then((result) => {
            this.homeList = result.dataList;
            result.dataList.forEach((item) => {
                if (item.type === 'banner') {
                    try {
                        const bannerList = JSON.parse(item.jsonStr);
                        this.bannerList = bannerList;
                    } catch (error) {
                        console.log('JSON ERROR');
                    }
                } else if (item.type === 'groupIntroduce') {
                    try {
                        const groupIntroduce = JSON.parse(item.jsonStr);
                        this.groupIntroduce = groupIntroduce;
                        this.groupIntroduceList = groupIntroduce.groupImages;
                    } catch (error) {
                        console.log('JSON ERROR');
                    }
                } else if (item.type === 'safeService') {
                    try {
                        const news = JSON.parse(item.jsonStr);
                        this.news = news;
                    } catch (error) {
                        console.log('JSON ERROR');
                    }
                }
            });
        }).catch(() => {});
    },
    methods: {
        goAboutIntro() {
            ajax.get('/web/common/navigate_list.json', { documentUrl: 'about' }).then((result) => {
                let index = 0;
                result.data.sonNavigateList.forEach((v, i) => {
                    if (v.documentUrl === 'aboutIntro') {
                        index = i;
                    }
                });
                this.$router.push({ name: 'about', hash: `#${index}` });
            }).catch(() => {});
        },
        bannerTo(banner) {
            if (banner.bannerLink) {
                document.location.href = banner.bannerLink;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.banner{
    width: 100%;
    height: 40vw;
    min-height: 480px;
    float: left;
    overflow: hidden;
    position: relative;
    p {
        margin: 0;
    }
    & > div{
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
.group_introduction {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    padding: 60px 0 30px;
    .group_introduction_content {
        width: 1000px;
        height: 100%;
        .title{
            width: 100%;
            margin-bottom: 20px;
            p {
                width: 100%;
                text-align: center;
                font-size:20px;
            }
            .cn {
                font-weight:600;
                color:rgba(74,74,74,1);
                &:first-letter {
                    // vertical-align: bottom;
                    font-size: 36px;
                }
            }
            .en {
                font-weight:600;
                color:rgba(199,31,75,1);
                letter-spacing: -1.2px;
            }
        }
        .content{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            .introduction_img{
                flex: 0 0 320px;
                min-width: 320px;
                max-width: 320px;
                display: flex;
                align-items: center;
                img {
                    width: 100%;
                    height: auto;
                }
            }
            .editor-gen{
                width: 860px;
                padding: 0 20px;
            }
        }
        .get_more{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 10px;
            .btn-more {
                display: inline-block;
                width: 128px;
                height: 32px;
                border:1px solid rgba(199,31,75,1);
                font-size:14px;
                font-weight:400;
                color:rgba(199,31,75,1);
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }
        }
        .swiper-button-prev{
            width:32px;
            height:32px;
            margin-top: -16px;
            outline: none;
            background-image: url('../../style/index_swiper_button_prev.png');
            background-size: 100% 100%;
        }
        .swiper-button-next{
            width:32px;
            height:32px;
            margin-top: -16px;
            outline: none;
            background-image: url('../../style/index_swiper_button_next.png');
            background-size: 100% 100%;
        }
    }
}
.news_block {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    padding: 60px 0 30px;
}
</style>
